import { render, staticRenderFns } from "./footer_bar.vue?vue&type=template&id=0754485c&scoped=true"
import script from "./footer_bar.vue?vue&type=script&lang=js"
export * from "./footer_bar.vue?vue&type=script&lang=js"
import style0 from "./footer_bar.vue?vue&type=style&index=0&id=0754485c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0754485c",
  null
  
)

export default component.exports